// extracted by mini-css-extract-plugin
export var sectionHeading = "TxtImg-module--sectionHeading--Kwu+s";
export var container = "TxtImg-module--container--XFkDW";
export var txtContainer = "TxtImg-module--txtContainer--eAhlz";
export var imgContainer = "TxtImg-module--imgContainer--HUFP4";
export var image = "TxtImg-module--image--eT2yn";
export var rotate = "TxtImg-module--rotate--c+oOR";